module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogined) ? _c('div', {
    staticClass: "orderContent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("我的订单")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryForm.orderType),
      expression: "queryForm.orderType"
    }],
    staticClass: "orderStatus",
    attrs: {
      "placeholder": "订单状态"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.queryForm, "orderType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "label": "全部订单"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "label": "待付款",
      "value": "unpaid"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "label": "待发货",
      "value": "pay"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "label": "已发货",
      "value": "delivery"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "label": "已完成",
      "value": "finish"
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "productName"
  }, [_vm._v("商品名称："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryForm.productName),
      expression: "queryForm.productName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名称"
    },
    domProps: {
      "value": (_vm.queryForm.productName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.queryForm, "productName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "dealDate"
  }, [_vm._v("\n      成交日期： \n      "), _c('el-date-picker', {
    attrs: {
      "suffix-icon": "el-icon-date",
      "type": "date",
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.queryForm.createStartTime),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "createStartTime", $$v)
      },
      expression: "queryForm.createStartTime"
    }
  }), _vm._v("\n      -\n      "), _c('el-date-picker', {
    attrs: {
      "suffix-icon": "el-icon-date",
      "type": "date",
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.queryForm.createEndTime),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "createEndTime", $$v)
      },
      expression: "queryForm.createEndTime"
    }
  })], 1), _vm._v(" "), _c('input', {
    staticClass: "searchBtn",
    attrs: {
      "type": "button",
      "value": "搜索"
    },
    on: {
      "click": function($event) {
        return _vm._orderList()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "orderList"
  }, [_vm._l((_vm.orderList), function(item, i) {
    return _c('table', {
      key: 'order_' + i
    }, [_c('tr', {
      staticClass: "addressHead"
    }, [_c('th', {
      attrs: {
        "colspan": "8"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateTime")(item.creationTime)))]), _c('span', {
      staticClass: "orderCode"
    }, [_vm._v("订单号："), _c('a', {
      on: {
        "click": function($event) {
          return _vm.orderDetail(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.orderCode))])]), _c('span', {
      staticClass: "supplierName"
    }, [_vm._v("供应商："), _c('a', {
      on: {
        "click": function($event) {
          return _vm.consultAsk(item)
        }
      }
    }, [_vm._v(_vm._s(item.supplierName))])]), _c('img', {
      attrs: {
        "title": "删除订单",
        "src": "http://img.static.knnnj.com/Default/c431046e-a858-4071-959e-70a09d70dcbb.png"
      },
      on: {
        "click": function($event) {
          return _vm._delOrder(item.id, i)
        }
      }
    })])]), _vm._v(" "), _vm._l((item.ordersDetials), function(good, j) {
      return _c('tr', {
        key: 'goods_' + j
      }, [_c('td', {
        staticClass: "productImg",
        attrs: {
          "title": "商品主图"
        }
      }, [_c('img', {
        attrs: {
          "src": good.defaultImage
        },
        on: {
          "click": function($event) {
            return _vm.goodsDetails(good.productId)
          }
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "productName",
        attrs: {
          "title": "商品名称"
        }
      }, [_vm._v(_vm._s(good.pName) + _vm._s(good.specName != '' && good.specName != '0' && good.specName != null ? "(" + good.specName + ")" : ""))]), _vm._v(" "), _c('td', {
        staticClass: "productPrice",
        attrs: {
          "title": "单价"
        }
      }, [_vm._v("￥" + _vm._s(Number(good.price).toFixed(2)))]), _vm._v(" "), _c('td', {
        staticClass: "productNum",
        attrs: {
          "title": "数量"
        }
      }, [_vm._v("x" + _vm._s(good.num))]), _vm._v(" "), _c('td', {
        staticClass: "productTotal",
        attrs: {
          "title": "合计"
        }
      }, [_vm._v("￥" + _vm._s(Number(good.price * good.num).toFixed(2)))]), _vm._v(" "), _c('td', {
        staticClass: "orderStatus",
        attrs: {
          "title": "订单状态"
        }
      }, [(!(item.ordersDetials.find(function (p) { return p.refundStatus > 0; })) && j == 0) ? _c('span', [_vm._v(" " + _vm._s(item.status))]) : _vm._e(), _vm._v(" "), (good.refundStatus > 0) ? _c('span', [_vm._v(" " + _vm._s(good.refundStatusDisplay))]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "orderOperate"
      }, [(j == 0) ? _c('div', [(!item.isPay && item.status == '待支付') ? _c('input', {
        staticClass: "orderOperateBtn",
        attrs: {
          "type": "button",
          "value": "去付款"
        },
        on: {
          "click": function($event) {
            return _vm.orderPayment(item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.isPay && item.status == '待发货') ? _c('input', {
        staticClass: "orderOperateBtn",
        attrs: {
          "type": "button",
          "value": "申请退款"
        },
        on: {
          "click": function($event) {
            return _vm.orderRefund(item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.isPay && !item.isDelivery && item.status == '退款中') ? _c('input', {
        staticClass: "orderOperateBtn",
        attrs: {
          "type": "button",
          "value": "取消退款"
        },
        on: {
          "click": function($event) {
            return _vm.cancelRefund(item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.isPay && item.status == '已发货') ? _c('input', {
        staticClass: "orderOperateBtn",
        attrs: {
          "type": "button",
          "value": "确认收货"
        },
        on: {
          "click": function($event) {
            return _vm.orderConfirm(item.id)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.isFinish && item.status == '已完成' && item.evaluateNum == 0) ? _c('input', {
        staticClass: "orderOperateBtn",
        attrs: {
          "type": "button",
          "value": "评价"
        },
        on: {
          "click": function($event) {
            return _vm.orderEvaluate(item)
          }
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.isPay && !item.isCancel && item.isDelivery && !item.isFinish && good.num > good.refundNum) ? _c('div', [_c('input', {
        staticClass: "orderOperateBtn",
        staticStyle: {
          "margin-top": "8px"
        },
        attrs: {
          "type": "button",
          "value": "申请退货"
        },
        on: {
          "click": function($event) {
            return _vm.orderReturn(item, good)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (good.refundStatus == 2 || good.refundStatusDisplay == '同意退款') ? _c('div', [_c('input', {
        staticClass: "orderOperateBtn",
        staticStyle: {
          "margin-top": "8px"
        },
        attrs: {
          "type": "button",
          "value": "寄回商品"
        },
        on: {
          "click": function($event) {
            return _vm.sendBack(item, good)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (good.refundStatus == 1) ? _c('div', [_c('input', {
        staticClass: "orderOperateBtn",
        staticStyle: {
          "margin-top": "8px"
        },
        attrs: {
          "type": "button",
          "value": "取消退货"
        },
        on: {
          "click": function($event) {
            return _vm.cancelReturn(good)
          }
        }
      })]) : _vm._e()])])
    })], 2)
  }), _vm._v(" "), (_vm.orderList.length == 0) ? _c('img', {
    attrs: {
      "src": "http://img.static.knnnj.com/Default/a5fd662b-be92-49de-9b8a-b36575efcc1c.png"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.noResult && !_vm.error) ? _c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('orderRefund', {
    ref: "orderRefund",
    on: {
      "fetch-data": _vm._orderList
    }
  }), _vm._v(" "), _c('orderReturn', {
    ref: "orderReturn",
    on: {
      "fetch-data": _vm._orderList
    }
  }), _vm._v(" "), _c('orderEvaluate', {
    ref: "orderEvaluate",
    on: {
      "fetch-data": _vm._orderList
    }
  }), _vm._v(" "), _c('sendBack', {
    ref: "sendBack",
    on: {
      "fetch-data": _vm._orderList
    }
  }), _vm._v(" "), _c('applyInvoice', {
    ref: "applyInvoice",
    on: {
      "fetch-data": _vm._orderList
    }
  }), _vm._v(" "), _c('consult', {
    ref: "consult",
    on: {
      "fetch-data": _vm._orderList
    }
  })], 1) : _c('div', {
    staticClass: "orderContent1"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.toLogin()
      }
    }
  }, [_vm._v("亲,请先登陆")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee76fd9c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/orderList.vue
// module id = 788
// module chunks = 2